import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { CONFIG } from '../config';
import { dispatchHandler } from '../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../helper/permissions';
import ParentModal from '../genericComponents/ParentModal';
import CreateAsnModalWrapper from '../components/digiVend/orders/CreateAsnModalWrapper';
import useCustomToast from '../hooks/useCustomToast';
import { Lock, Clock, FileText, AlertCircle, Check } from 'lucide-react';
import CreateLrWrapper from '../components/digiVend/logistics/CreateLrWrapper';
import moment from 'moment';
import CreateShipmentWithLr from './CreateShipmentWithLr';

function PortalDocument(props) {
    const location = useLocation();

    const generalStore = useSelector(state => state.generalStore);
    const digivendStore = useSelector((state) => state.digivendStore);

    const customToast = useCustomToast();

    const getParams = () => {
        const urlSearchParams = new URLSearchParams(location.search), p = Object.fromEntries(urlSearchParams.entries());
        return {
            type: p.type,
            id: p.id,
            mode: p.mode || 'preview',
            sourceType: p.sourceType,
            sourceId: p.sourceId,
            token: p?.token ?? null,
            code: p.code,
            hash: p.hash
        };
    };

    const [content, setContent] = useState(null);
    const [error, setError] = useState(null);
    const [vendConfig, setVendConfig] = useState({});
    const [selectedModal, setSelectedModal] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [prevSelectedData, setPrevSelectedData] = useState(null);
    const [successData, setSuccessData] = useState({});
    const [storeASNData, setStoreASNData] = useState(null);
    const [type, setType] = useState(false)

    // const params = getParams();
    const [params, setParams] = useState(getParams());

    const dispatch = useDispatch();

    useEffect(() => {
        if (generalStore?.getDocumentDetailsData?.isSuccess) {
            const paramsData = new URLSearchParams(generalStore?.getDocumentDetailsData?.data?.data?.url), data = Object.fromEntries(paramsData.entries());
            setParams(data);
            callAPI(data);
        }
        else if (generalStore?.getDocumentDetailsData?.isError) {
            setError(generalStore?.getDocumentDetailsData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : generalStore?.getDocumentDetailsData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [generalStore?.getDocumentDetailsData])

    useEffect(() => {
        if (generalStore?.getPortalDocPrevData?.isSuccess) {
            setContent(generalStore?.getPortalDocPrevData?.data?.data);
            setError(null);
        }
        else if (generalStore?.getPortalDocPrevData?.isError) {
            setError(generalStore?.getPortalDocPrevData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : generalStore?.getPortalDocPrevData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [generalStore?.getPortalDocPrevData]);

    useEffect(() => {
        if (digivendStore?.["getSystemConfigKeysData"]?.isSuccess) {
            setVendConfig(digivendStore?.["getSystemConfigKeysData"]?.data?.resource || {});
        }
        else if (digivendStore?.["getSystemConfigKeysData"]?.isError) {
            setError(digivendStore?.["getSystemConfigKeysData"]?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : digivendStore?.getSystemConfigKeysData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [digivendStore?.["getSystemConfigKeysData"]]);

    useEffect(() => {
        if (generalStore?.getTableComponentListData?.isSuccess) {
            setSelectedData(generalStore?.getTableComponentListData?.data?.resource?.[0]);
            setPrevSelectedData(generalStore?.getTableComponentListData?.data?.resource?.[0]);
            if (params?.type === "CREATE_SHIPMENT" || params?.type === "CREATE_SHIPMENT_ALONG_WITH_LR" || params?.type == "CREATE_SHIPMENT_WITH_LR") {
                dispatchHandler(dispatch, "checkAsnRestrictionRequest", { orderId: params?.id || "" }, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
            }
            else if (params?.type == "CREATE_LR") {
                setSelectedModal(params?.type);
            }
            else setError("INVALID_DOC_TYPE")
        }
        else if (generalStore?.getTableComponentListData?.isError) {
            setError(generalStore?.getTableComponentListData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : generalStore?.getTableComponentListData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [generalStore?.getTableComponentListData]);

    useEffect(() => {
        if (digivendStore?.createMultipleAsnData?.isSuccess) {
            setSelectedModal(null);
            setSuccessData({ asnNumber: digivendStore?.createMultipleAsnData?.data?.resource?.shipmentAdviceCode })
        }
        else if (digivendStore?.createMultipleAsnData?.isError) {
            setError(digivendStore?.createMultipleAsnData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : digivendStore?.createMultipleAsnData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [digivendStore?.createMultipleAsnData]);

    useEffect(() => {
        if (digivendStore?.vendorlogiLrCreateData?.isSuccess) {
            setSelectedModal(null);
            setSuccessData({ lrNumber: digivendStore?.vendorlogiLrCreateData?.data?.message })
        }
        else if (digivendStore?.vendorlogiLrCreateData?.isError) {
            setError(digivendStore?.vendorlogiLrCreateData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : digivendStore?.vendorlogiLrCreateData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [digivendStore?.vendorlogiLrCreateData]);

    useEffect(() => {
        if (digivendStore?.createShipmentWithLrData?.isSuccess) {
            setSelectedModal(null);
            setSuccessData({ asnNumber: digivendStore?.createShipmentWithLrData?.data?.resource?.shipmentAdviceCode })
        }
        else if (digivendStore?.createShipmentWithLrData?.isError) {
            setError(digivendStore?.createShipmentWithLrData?.message?.errorMessage?.includes?.("Unauthorised Access") ? "UNAUTHORIZED_ACCESS" : digivendStore?.createShipmentWithLrData?.message?.errorMessage?.includes?.("Session Expired") ? "SESSION_EXPIRED" : "API_ERROR");
        }
    }, [digivendStore?.createShipmentWithLrData]);

    useEffect(() => {
        if (digivendStore?.checkAsnRestrictionData?.isSuccess) {
            if (digivendStore?.checkAsnRestrictionData?.data?.resource?.asnRestrict == 1) {
                customToast({
                    title: "An Error Occured!",
                    description: digivendStore?.checkAsnRestrictionData?.data?.resource?.message || "Can not Create ASN",
                    status: "error",
                });
                setSelectedData(prevSelectedData);
                setPrevSelectedData(null);
            }
            else if (params?.type === "CREATE_SHIPMENT_WITH_LR") {
                setType("CREATE_SHIPMENT_WITH_LR")
            }
            else {
                setSelectedModal("CREATE_SHIPMENT");
            }
        }
    }, [digivendStore?.checkAsnRestrictionData?.isSuccess]);

    const DOCUMENT_WORKFLOW = {
        PO_PDF: {
            label: 'Purchase Order',
        },
        ASN_PDF: {
            label: 'Advance Shipment Notice',
        },
        CREATE_SHIPMENT: {
            label: "Create Shipment"
        },
        CREATE_SHIPMENT_ALONG_WITH_LR: {
            label: "Create Shipment with LR"
        },
        CREATE_LR: {
            label: "Create LR"
        },
        CREATE_SHIPMENT_WITH_LR: {
            label: "Create Shipment With LR"
        }
    };

    const workflowConfig = DOCUMENT_WORKFLOW[params.type];

    const callAPI = (params) => {
        let obj = {
            PO_PDF: "PO_PDF_VIEW"
        };
        let token = params?.token;
        let payload = {
            apiUrl: "/pdf/convertToHTML/getHtml",
            documentId: params?.id || "",
            documentCode: params?.code || "",
            type: obj?.[params.type] || params.type,
            returnHtmlOnly: true,
            baseUrl: CONFIG.NOTIFICATION_ROUTE_PROD,
            token: token
        };
        dispatchHandler(dispatch, "getPortalDocPrevRequest", payload, { "x-auth-token": token })
    };

    useEffect(() => {
        if (params?.token) {
            sessionStorage.setItem("token", params?.token);
        }
    }, [params?.token]);

    useEffect(() => {
        if (!params?.type) {
            let payload = {
                hash: params?.hash
            };
            dispatchHandler(dispatch, "getDocumentDetailsRequest", payload)
            return;
        }
        if (!sessionStorage?.getItem?.('token')) {
            setError("AUTH_TOKEN_MISSING");
            return;
        }

        const handler = workflowConfig;
        if (!handler) {
            setError("INVALID_DOC_TYPE");
            return;
        }
        if (params?.type == "CREATE_SHIPMENT" || params?.type == "CREATE_SHIPMENT_ALONG_WITH_LR" || params?.type == "CREATE_SHIPMENT_WITH_LR") {
            dispatchHandler(dispatch, "getSystemConfigKeysRequest", {}, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
            let payload = {
                type: 3,
                pageNo: 1,
                pageSize: 10,
                sortedBy: "",
                sortedIn: "",
                search: params?.code || "",
                filter: {},
                status: "APPROVED",
                displayName: "VENDOR_PENDING_ALL",
                apiUrl: "/purchase/order/get/pending/order/data",
                baseUrl: CONFIG.SM_BACKEND_BASE_URL,
            }
            dispatchHandler(dispatch, "getTableComponentListRequest", payload, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
        }
        else if (params?.type == "CREATE_LR") {
            dispatchHandler(dispatch, "getSystemConfigKeysRequest", {}, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
            let payload = {
                type: 3,
                pageNo: 1,
                pageSize: 10,
                sortedBy: "",
                sortedIn: "",
                search: params?.code || "",
                filter: {},
                status: "SHIPMENT_SHIPPED",
                displayName: "ENT_LR_PROCESSING_ALL",
                apiUrl: "/purchase/logistics/get/all/lrprocessing",
                baseUrl: CONFIG.SM_BACKEND_BASE_URL,
            }
            dispatchHandler(dispatch, "getTableComponentListRequest", payload, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
        }

    }, []);

    const handleChange = (type, data) => {
        switch (type) {
            case "createAsnInspectionFromAsn": {
                dispatchHandler(dispatch, "checkAsnRestrictionRequest", { orderId: data?.[0]?.orderId || "" }, { ...getPermissionKey("purchase", "orders", "view"), "x-auth-token": params?.token });
                setPrevSelectedData(selectedData);
                setSelectedData(data?.[0]);
                break;
            }
            case "createLrRequestFromLR": {
                let today = moment(new Date()).format("YYYY-MM-DD");
                var qcNotRequire = data?.filter?.((data) => data.qcStatus == "Re-Inspection" || data.qcStatus == "To Be Done Later")
                if (qcNotRequire.length != 0) {
                    customToast({ title: "Please complete the inspection for perform this action.", status: 'warning' })
                }
                else if (vendConfig?.asnBufferDaysRequired?.toLowerCase?.() === "true" && data.some((data) => today > moment(data.validToSelectionDate).add(vendConfig?.asnBufferDays, 'days').format("YYYY-MM-DD"))) {
                    customToast({ title: "You Have Exceeded From Your ASN Validation Date.", status: 'warning' })
                }
                else if (vendConfig?.lrCreationRequired?.toLowerCase?.() === "true" && data.some((data) => today > moment(data.updatedOnSelectionDate).add(+(vendConfig.lrCreationTAT), 'days').format("YYYY-MM-DD"))) {
                    customToast({ title: "You Have Exceeded From Your LR Creation Date.", status: 'warning' })
                }
                else if (vendConfig?.lrCreationRequired?.toLowerCase?.() !== "true" && data.some((data) => data?.aptDate && moment(data.aptDate).isBefore(moment(), "d"))) {
                    customToast({ title: "Invalid Appointment Date - Edit the ASN to initiate re-appointment of Shipment.", status: 'warning' })
                }
                else {
                    setTimeout(() => {
                        setSelectedData(data)
                    }, 500);
                }
                break;
            }
            case "storeASNData": {
                let selectedDataUpdate = { ...selectedData };
                delete selectedDataUpdate?.dueDays;
                delete selectedDataUpdate?.orderCode;
                delete selectedDataUpdate?.id;
                selectedDataUpdate["shipmentAdviceCode"] = "";
                selectedDataUpdate["poType"] = selectedDataUpdate?.poicode == "poicode" ? "NON-SET" : "SET";
                setSelectedData(selectedDataUpdate);
                setStoreASNData(data);
                setTimeout(() => {
                    setSelectedModal("CREATE_LR");
                }, 500);
                break;
            }
            case "submitASNLR": {
                if (storeASNData?.length > 0) {
                    let payload = storeASNData?.map((item) => {
                        return {
                            ...item,
                            lrNode: data
                        }
                    })
                    dispatchHandler(dispatch, "createShipmentWithLrRequest", payload, getPermissionKey("purchase", "shipment", "create"))
                }
                break;
            }
            default:
                break;
        }
    }

    function ContentRenderer({ content }) {
        if (params?.type == "PO_PDF" || params?.type == "ASN_PDF") {
            return (
                <iframe
                    srcdoc={content}
                    style={{ width: '100%', height: '100vh', border: 'none', borderRadius: 6 }}
                    title="Document Preview"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-downloads, allow-popups-to-escape-sandbox"
                />
            );
        }
    }

    const getParentChildProps = () => {
        switch (selectedModal) {
            case "CREATE_SHIPMENT": {
                return {
                    animationType: "bottom",
                    zIndexClass: "zi998",
                    closeModal: () => { },
                    modalHeading: `Create ${vendConfig?.inspectionRequired?.toLowerCase() === "true" ? "Inspection" : "ASN"}`,
                    parentModalOuterMostClassName: "flex items-center justify-center",
                    postitionProps: { position: "relative" },
                    dimensions: {
                        width: "90vw",
                        height: "90vh",
                        maxHeight: "740px",
                        maxWidth: "1270px",
                        borderRadius: 5
                    },
                    vendConfig: vendConfig,
                    selectedData: selectedData,
                    headerKey: {
                        setInner: {
                            name: "Set",
                            key: "VENDOR_PENDING_SET",
                        },
                        itemInner: {
                            name: "Item",
                            key: "VENDOR_PENDING_ICODE_ITEM",
                        },
                    },
                    isCloseBlocked: true,
                    closeModalV2: () => { },
                    handleInputChange: handleChange,
                    prevParams: params
                };
            }
            case "CREATE_LR": {
                return {
                    zIndexClass: "zi998",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "90vw", height: "90vh", maxHeight: '740px', maxWidth: '1360px' },
                    selectedData: selectedData,
                    modalHeading: "NEW LOGISTICS REQUEST",
                    vendConfig: vendConfig,
                    handleInputChange: handleChange,
                    isWithoutLogin: true,
                    prevParams: params,
                    closeModal: () => { }
                }
            }

            default:
                break;
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "CREATE_SHIPMENT": return CreateAsnModalWrapper;
            case "CREATE_LR": return CreateLrWrapper;
            default: return () => <></>
        }
    };

    const ERROR_CONFIG = {
        AUTH_TOKEN_MISSING: {
            icon: "lock",
            color: '#BA7517',
            bg: '#FAEEDA',
            title: 'Access token missing',
            desc: 'No authentication token was found. Please log in to Supplymint to access this document.',
            actions: [{ label: 'Go to login', primary: true, onClick: () => window.location.href = '/' }],
        },
        SESSION_EXPIRED: {
            icon: 'clock',
            color: '#185FA5',
            bg: '#E6F1FB',
            title: 'Your session has timed out',
            desc: "You've been inactive for a while and your session has expired. Please log in again to continue.",
            actions: [{ label: 'Log in again', primary: true, onClick: () => window.location.href = '/' }],
        },
        INVALID_DOC_TYPE: {
            icon: 'file',
            color: '#993C1D',
            bg: '#FAECE7',
            title: 'This document type is not supported',
            desc: 'The document type in the URL is not recognised. Please check the link or go back to the portal.',
        },
        API_ERROR: {
            icon: 'alert',
            color: '#A32D2D',
            bg: '#FCEBEB',
            title: 'Something went wrong',
            desc: "We couldn't load this document right now. This is usually temporary — please try again in a moment.",
            actions: [
                { label: 'Try again', primary: true, onClick: () => window.location.reload() },
            ],
        },
        UNAUTHORIZED_ACCESS: {
            icon: 'alert',
            color: '#A32D2D',
            bg: '#FCEBEB',
            title: 'Unauthorized Access',
            desc: "You don't have permission to access this document.",
            actions: [
                { label: 'Try again', primary: true, onClick: () => window.location?.reload?.() },
            ],
        }
    };

    const ErrorScreen = () => {
        const ICON_MAP = {
            lock: Lock,
            clock: Clock,
            file: FileText,
            alert: AlertCircle,
        };

        const config = ERROR_CONFIG?.[error];
        const Icon = ICON_MAP?.[config?.icon];

        return (
            <div className="p-4 font-sans">

                <div className="w-full md:w-[210mm] min-h-screen md:h-[100vh] mx-auto border rounded-lg flex flex-col items-center justify-center px-4 md:px-10 py-8 md:py-12">

                    <div
                        className="w-[56px] h-[56px] md:w-[72px] md:h-[72px] rounded-full flex items-center justify-center mb-4 md:mb-6"
                        style={{ background: config.bg }}
                    >
                        <Icon color={config.color} size={24} className="md:size-8" />
                    </div>

                    <p className="text-[10px] md:text-[11px] uppercase tracking-widest mb-2 md:mb-3 font-medium text-center" style={{ color: config.color }}>
                        {config.code}
                    </p>

                    <h2 className="text-lg md:text-[22px] font-medium text-center mb-2 px-2">
                        {config.title}
                    </h2>

                    <p className="text-sm md:text-[14px] text-gray-500 text-center max-w-full md:max-w-[340px] mb-6 md:mb-8 px-2">
                        {config.desc}
                    </p>

                    {config.meta && (
                        <div className="bg-gray-100 rounded-md p-3 md:p-[16px] w-full max-w-full md:max-w-[360px] mb-6 md:mb-8">
                            {Object.entries(config?.meta || {})?.map(([k, v]) => (
                                <div key={k} className="flex justify-between text-xs md:text-sm py-1">
                                    <span className="text-gray-500">{k}</span>
                                    <span className="font-medium text-right">{v}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                        {config?.actions?.map((action) => (
                            <button
                                key={action.label}
                                onClick={action.onClick}
                                className={`w-full md:w-auto px-4 md:px-5 py-2 rounded-md text-sm font-medium border ${action.primary ? "text-white border-none" : "text-gray-500 border-gray-300"}`}
                                style={action.primary ? { background: config.color } : {}}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>

                </div>
            </div>
        );
    }

    const SUCCESS_CONFIG = {
        ASN_CREATED: (data) => ({
            color: "#3B6D11",
            bg: "#EAF3DE",
            badge: "ASN created successfully",
            title: "Advance Shipment Notice Raised",
            desc: () => (
                <>
                    ASN has been created from Purchase Order{" "}
                    <span className="text-gray-900 font-medium">
                        {data.poNumber}
                    </span>{" "}
                </>
            ),

            details: [
                { label: "ASN Number", value: data.asnNumber, highlight: true },
                { label: "Created From", value: data.poNumber },
                { label: "Created On", value: "TODAY" },
            ],
            docId: data.asnNumber,
        }),
        LR_CREATED: (data) => ({
            color: "#3B6D11",
            bg: "#EAF3DE",
            badge: "LR created successfully",
            desc: () => (
                <>
                    {data.desc}
                </>
            ),

            details: [
                // { label: "ASN Number", value: data.asnNumber, highlight: true },
                { label: "Created From", value: data.poNumber },
                { label: "Created On", value: "TODAY" },
            ],

            // docId: data.asnNumber,
        }),
    };


    const SuccessScreen = ({ config }) => {
        const today = new Date().toLocaleDateString("en-IN", {
            year: "numeric",
            month: "short",
            day: "2-digit",
        });

        return (
            <div className="flex justify-center p-[16px] font-sans bg-gray-50">

                <div className="w-full md:w-[210mm] min-h-screen md:h-[100vh] border rounded-lg flex flex-col items-center justify-center px-4 md:px-10 py-8 md:py-12 bg-white">

                    <div
                        className="w-[56px] h-[56px] md:w-[72px] md:h-[72px] rounded-full flex items-center justify-center mb-4 md:mb-6"
                        style={{ background: config.bg }}
                    >
                        <Check size={24} className="md:size-8" style={{ color: config.color }} />
                    </div>

                    <div
                        className="flex items-center gap-2 text-[10px] md:text-[11px] uppercase tracking-wide font-medium px-2 md:px-3 py-1 rounded-md mb-3 md:mb-4"
                        style={{ background: config.bg, color: config.color }}
                    >
                        <Check size={10} className="md:size-3" />
                        {config.badge}
                    </div>

                    <h2 className="text-lg md:text-[22px] font-medium text-center mb-2 px-2">
                        {config.title}
                    </h2>

                    <p className="text-sm md:text-[14px] text-gray-500 text-center max-w-full md:max-w-[340px] mb-6 md:mb-7 leading-relaxed px-2">
                        {typeof config.desc === "function" ? config.desc() : config.desc}
                    </p>

                    {config.details && (
                        <div className="w-full max-w-full md:max-w-[380px] bg-gray-100 rounded-md p-[12px] md:p-[16px] mb-6 md:mb-7">
                            <p className="text-[10px] md:text-[11px] uppercase tracking-wide text-gray-400 mb-2 md:mb-3 font-medium">
                                Document details
                            </p>

                            {config.details?.map((item) => (
                                <div
                                    key={item.label}
                                    className="flex justify-between items-start gap-2 py-1.5 text-xs md:text-sm border-b last:border-none"
                                >
                                    <span className="text-gray-500">{item.label}</span>

                                    <span
                                        className={`font-medium text-right ${item.highlight ? "" : "text-gray-900"
                                            }`}
                                        style={item.highlight ? { color: config.color } : {}}
                                    >
                                        {item.value === "TODAY" ? today : item.value}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto mb-6 md:mb-8">
                        {config.actions?.map((action) => (
                            <button
                                key={action.label}
                                onClick={action.onClick}
                                className={`w-full md:w-auto px-4 md:px-5 py-2 rounded-md text-sm font-medium border ${action.primary
                                        ? "text-white border-none"
                                        : "text-gray-500 border-gray-300"
                                    }`}
                                style={action.primary ? { background: config.color } : {}}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>

                    {/* {config?.docId && (
                        <div className="w-full text-center text-[10px] md:text-xs text-gray-400 border-t pt-4 md:pt-5 px-2">
                            Document ID:{" "}
                            <span className="text-gray-600 font-medium break-all">
                                {config?.docId}
                            </span>
                        </div>
                    )} */}
                </div>
            </div>
        );
    }

    if (error) return <ErrorScreen errorCode={error} />;

    const data = {
        asnNumber: successData?.asnNumber || "",
        poNumber: params?.code || "",
    };
    if (successData?.asnNumber) return <SuccessScreen config={SUCCESS_CONFIG.ASN_CREATED(data)} />;
    if (successData?.lrNumber) return <SuccessScreen config={SUCCESS_CONFIG.LR_CREATED(data)} />;
    if (type == "CREATE_SHIPMENT_WITH_LR") return <CreateShipmentWithLr
        selectedData={selectedData} prevParams={params} vendConfig={vendConfig} handleInputChange={handleChange}
        headerKey={{
            setInner: {
                name: "Set",
                key: "VENDOR_PENDING_SET",
            },
            itemInner: {
                name: "Item",
                key: "VENDOR_PENDING_ICODE_ITEM",
            },
        }}
    />

    return (
        <div className={`portal-page mx-auto flex justify-center md:p-[8px] ${(params?.type != "CREATE_SHIPMENT" || params?.type != "CREATE_LR") ? "bg-[#fafafa]" : ""}`}>
            <div className='w-[210mm] bg-white shadow-[0_5px_15px_rgba(0,0,0,0.1)]'>
                <ContentRenderer content={content} />
            </div>
            {selectedModal && (
                <ParentModal
                    getParentChildProps={getParentChildProps()}
                    childComponent={getChildComponent()}
                    closeModal={() => { }}
                />
            )}
        </div>
    )
}

export default PortalDocument